import React from 'react';
import Copyright from './Copyright';

import { footerData } from '../data';
import { motion as m } from 'framer-motion';
import { staggerContainer, fadeIn } from '../variants';
import { AiFillFacebook, AiFillInstagram, AiFillLinkedin } from 'react-icons/ai';

const Footer = () => {
  const { contact, hours, social } = footerData
  return (
    <footer className='relative bg-cover bg-black z-20 bg-footer h-[600px] overflow-hidden lg:h-96 flex items-center'>
      <div className="absolute top-0 right-0 bottom-0 left-0 bg-black bg-opacity-70" />
      <div className='container relative mx-auto'>
        <m.div
        variants={staggerContainer}
        initial='hidden'
        whileInView={'show'}
        viewport={{once: false, amount: 0.2}} 
        className='h-full flex flex-col gap-y-5 lg:flex-row lg:gap-x-[100px] bg-accent rounded bg-opacity-20 p-14'>

          <m.div className='flex-1 w-[300px]'>
            <m.div 
            variants={fadeIn('right', 'spring', 0.3, 1.1)}
            className='capitalize text-[20px] lg:text-[22px]
            font-tertiary text-accent mb-2'>{contact.title}</m.div>
            <m.div variants={fadeIn('right', 'spring', 0.4, 1.1)} className='capitalize text-white'>{contact.address}</m.div>
            <m.a variants={fadeIn('right', 'spring', 0.6, 1.1)} href="tel:+94716418542" className='capitalize text-accent hover:text-yellow-300 transition duration-500'>{contact.directions}</m.a>
          </m.div>

          <m.div className='flex-1 w-[300px]'>
          <m.div variants={fadeIn('down', 'tween', 0.3, 1.1)} className='capitalize text-[20px] lg:text-[22px]
            font-tertiary text-accent mb-2'>{hours.title}</m.div>
            <div className='flex gap-x-[44px]'>
              {hours.program.map((item, index) => {
                return (
                <div className='capitalize' key={index}>
                    <div>
                      <m.div variants={fadeIn('down', 'tween', 0.4, 1.1)} className='capitalize text-white'>{item.days}</m.div>
                      <m.div variants={fadeIn('down', 'tween', 0.3, 1.1)} className='capitalize text-amber-600'>{item.hours}</m.div>
                    </div>
                  </div>
                );
              })}
            </div>
          </m.div>

          <m.div className='flex-1 w-[300px]'>
            <m.div variants={fadeIn('left', 'spring', 0.3, 1.1)} className='capitalize text-[20px] lg:text-[22px]
            font-tertiary text-accent mb-2'>{social.title}</m.div>
            <m.div variants={fadeIn('left', 'spring', 0.4, 1.1)} className='flex flex-row gap-3'>
              <a href='https://www.instagram.com/_bunny98_/' rel="noreferrer" target='_blank'>
              <AiFillInstagram className='text-white text-5xl hover:text-yellow-300 transition duration-500'/>
              </a>
              
              <a href='https://web.facebook.com/vlochana' rel="noreferrer" target='_blank'>
              <AiFillFacebook className='rounded-[25px] text-5xl text-white hover:text-yellow-300 transition duration-500' />
              </a>

              <a href='https://www.linkedin.com/in/viduralochana/' rel="noreferrer" target='_blank'>
              <AiFillLinkedin className='rounded-[25px] text-5xl text-white hover:text-yellow-300 transition duration-500' />
              </a>

            </m.div>
            <m.a variants={fadeIn('left', 'spring', 0.5, 1.1)} href="tel:+94716418542" className='capitalize text-accent hover:text-yellow-300 transition duration-500'>{contact.phone}</m.a>
          </m.div>

        </m.div>
        <Copyright />
      </div>
    </footer>
  );
};

export default Footer;
